<div id="form-container">
    <form
        [formGroup]="form"
        id="main-form"
        data-testid="main-form"
        class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
        (ngSubmit)="onSubmit()">
        <div id="heading">
          <h3 class="ui-heading-3-bold">Publication</h3>
          <span class="status-badge"
                [class.status-in-progress]="publication().metadata.status === 'In Progress'"
                [class.status-published]="publication().metadata.status === 'Published'"
                [class.status-presented]="publication().metadata.status === 'Presented'"
                [class.status-rejected]="publication().metadata.status === 'Rejected'"
                [class.status-submitted]="publication().metadata.status === 'Submitted'"
                [class.status-accepted]="publication().metadata.status === 'Accepted'"
                [class.status-planned]="publication().metadata.status === 'Planned'">
            {{ publication().metadata.status }}
          </span>
        </div>
        <form id="metadata" [formGroup]="form.controls.metadata">
            <h4 class="ui-heading-4--m">Metadata</h4>

            <app-expandable-input label="Full Title" [control]="form.controls.metadata.controls.title" [data-testid]="'title'"></app-expandable-input>
            @if(!isViewer){
                <rds-form-field labelPosition="side-left">
                    <rds-control-label>Document Number</rds-control-label>
                    <input rdsInput [value]="publication().metadata.documentNumber || 'DV - No Document Number'" readonly class="monospace" data-testid="documentNumber" />
                </rds-form-field>
            }
            <section class="rds-form-field list">
                <p class="rds-form-field__label list-label">Authors</p>
                <div class="list-content">
                    @for (author of form.controls.metadata.controls.authors.controls; track author) {
                      @if(authorListExpanded || $index == 0) {
                        <rds-form-field labelPosition="side-left">

                            <input rdsInput [formControl]="author" data-testid="authors"/>
                        </rds-form-field>
                      }
                    }
                </div>
            </section>
          @if(form.controls.metadata.controls.authors.controls.length > 1){
            @if(!authorListExpanded){
                <button rds-text-button (click)="authorListExpanded = true" class="ms-auto" type="button" data-testid="authors-expand">
                  <rds-icon namespace="filled" icon="caret_down"/>
                  Show {{form.controls.metadata.controls.authors.controls.length -1}} more
                </button>
            }
            @else {
                <button rds-text-button (click)="authorListExpanded = false" class="ms-auto" type="button" data-testid="authors-colapse">
                  <rds-icon namespace="filled" icon="caret_up"/>
                  Show less
                </button>
            }
          }
           <app-expandable-input 
             label="Target" 
             [control]="targetControl" 
             [data-testid]="'target'"
             [tooltip]="targetTooltip">
           </app-expandable-input>

            <section class="rds-form-field list">
                <p class="rds-form-field__label list-label">Studies</p>
                <div class="list-content">
                    @for (study of form.controls.metadata.controls.studies.controls; track study) {
                        <rds-form-field labelPosition="side-left">
                            <input
                                rdsInput
                                [formControl]="study"
                                placeholder="Study Number, Study Name"
                                data-testid="studies"
                            />
                        </rds-form-field>
                    }
                </div>
            </section>
            <rds-form-field labelPosition="side-left">
                <rds-control-label>Due Date</rds-control-label>
                <input
                    rdsInput
                    formControlName="date"
                    data-testid="date"
                />
            </rds-form-field>
            @if(shouldShowPubCenterLink()){
                <div id="pubcenter-link">
                    <section id="pubcenter-link-section">
                    <div id="pubcenter-link-row" style="display: flex; align-items: center; justify-content: space-between;">
                        <p id="role-header" class="rds-form-field__label list-label" style="margin: 0;">
                            PubCenter
                        </p>
                        <div id="pubcenter-link-content">
                            <button rds-text-button type="button" (click)="openPubCenterLink()">
                                View Abstract / Publication
                                <rds-icon namespace="filled" icon="link"></rds-icon>
                            </button>
                        </div>
                    </div>
                    </section>
                  </div>
            }

        </form>
                <rds-divider></rds-divider>
                <!-- Unified Pillars & Audiences Section (moved above Custom Data) -->
                        <app-pillars-audiences-section
                          entityType="publication"
                          [entityId]="publication().metadata.documentNumber"
                          [isViewer]="isViewer"
                          [initialPillars]="publication().strategicPillars || []"
                          [initialAudiences]="publication().audiences || []"
                          (pillarChanged)="onPillarChanged($event)"
                          (audienceChanged)="onAudienceSelectionChange($event)">
                        </app-pillars-audiences-section>

                <div id="editable">
            <div id="priority">
                <section id="prio-section" class="list">
                    <h4 id="prio-header" class="ui-heading-4--m">
                      Priority <span class="c-error">*</span>
                      
                        <rds-empty-state size="xs">
                            <rds-icon rds-empty-state-icon namespace="outlined" icon="circle_info"
                                      #popover="rdsPopover" (click)="popover.toggle()"
                                      [class]="!form.controls.priority.valid? 'c-error-pressed' :
                                      (!form.controls.priorityLinks.valid? 'c-warning-pressed' : 'c-primary-pressed')"
                                      [rdsPopoverHasBackdrop]="true"
                                      [rdsPopover]="popoverTextContent"
                                      [rdsPopoverShowCloseButton]="false"/>
                        </rds-empty-state>
                        <ng-template #popoverTextContent>
                            <rds-popover-text-content id="textExample">
                                <h4 rds-popover-header>Required links due to priority level:</h4>
                                <div rds-popover-paragraph>
                                    <p class="d-flex justify-content-between flex-wrap">
                                        <span>Data training</span>
                                        <rds-icon
                                            namespace="outlined"
                                            [icon]="priorityLinkIsRequired('dataTraining')? (priorityLinkIsEmpty('dataTraining')? 'circle_close' : 'circle_checkmark') : 'circle_subtract'"
                                            class="check-icon bg-solid-hover-select"
                                            [class]="priorityLinkIsRequired('dataTraining')? (priorityLinkIsEmpty('dataTraining')? 'c-error-pressed' : 'c-success-pressed') : 'c-neutral-pressed'"/>
                                    </p>
                                    <p class="d-flex justify-content-between flex-wrap">
                                        <span>Publication As Slides</span>
                                        <rds-icon
                                            namespace="outlined"
                                            [icon]="priorityLinkIsRequired('publicationAsSlides')? (priorityLinkIsEmpty('publicationAsSlides')? 'circle_close' : 'circle_checkmark') : 'circle_subtract'"
                                            class="check-icon bg-solid-hover-select"
                                            [class]="priorityLinkIsRequired('publicationAsSlides')? (priorityLinkIsEmpty('publicationAsSlides')? 'c-error-pressed' : 'c-success-pressed') : 'c-neutral-pressed'"/>
                                    </p>
                                    <p class="d-flex justify-content-between flex-wrap">
                                        <span>Metis Statements</span>
                                        <rds-icon
                                            namespace="outlined"
                                            [icon]="priorityLinkIsRequired('metisStatements')? (priorityLinkIsEmpty('metisStatements')? 'circle_close' : 'circle_checkmark') : 'circle_subtract'"
                                            class="check-icon bg-solid-hover-select"
                                            [class]="priorityLinkIsRequired('metisStatements')? (priorityLinkIsEmpty('metisStatements')? 'c-error-pressed' : 'c-success-pressed') : 'c-neutral-pressed'"/>
                                    </p>
                                    <p class="ui-label-s pt-2">
                                      Selecting the priority level is mandatory. Including the recommended links is optional.
                                    </p>
                                </div>
                            </rds-popover-text-content>
                        </ng-template>
                    </h4>
                    <div id="prio-content">
                        <rds-radio-group class="d-flex flex-row gap-5" formControlName="priority">
                            <rds-radio-button [value]="1" data-testid="priority-1">1</rds-radio-button>
                            <rds-radio-button [value]="2" data-testid="priority-2">2</rds-radio-button>
                            <rds-radio-button [value]="3" data-testid="priority-3">3</rds-radio-button>
                        </rds-radio-group>
                    </div>
                </section>
                <form [formGroup]="form.controls.priorityLinks" id="priority-form">
                    <rds-form-field labelPosition="side-left">
                        <rds-control-label>Data Training</rds-control-label>
                        <input
                            rdsInput
                            formControlName="dataTraining"
                            placeholder="Link"
                            data-testid="dataTraining"
                        />
                        @if(form.controls.priorityLinks.get('dataTraining')?.value) {
                            <div class="d-flex align-items-center justify-content-end">
                                <button rds-icon-button size="m" class="ms-2" type="button">
                                    <rds-icon namespace="filled" icon="link" (click)="openTrainingLink()"></rds-icon>
                                </button>
                            </div>
                        }
                    </rds-form-field>
                    <rds-form-field labelPosition="side-left">
                        <rds-control-label>Publication As Slides</rds-control-label>
                        <input
                            rdsInput
                            formControlName="publicationAsSlides"
                            placeholder="Link"
                            data-testid="publicationAsSlides"
                        />
                        @if(form.controls.priorityLinks.get('publicationAsSlides')?.value) {
                            <div class="d-flex align-items-center justify-content-end">
                                <button rds-icon-button size="m" class="ms-2" type="button">
                                    <rds-icon namespace="filled" icon="link" (click)="openSlidesLink()"></rds-icon>
                                </button>
                            </div>
                        }
                    </rds-form-field>
                    <rds-form-field labelPosition="side-left">
                        <rds-control-label>Metis Statements</rds-control-label>
                        <input
                            rdsInput
                            formControlName="metisStatements"
                            placeholder="Link"
                            data-testid="metisStatements"
                        />
                        @if(form.controls.priorityLinks.get('metisStatements')?.value) {
                            <div class="d-flex align-items-center justify-content-end">
                                <button rds-icon-button size="m" class="ms-2" type="button">
                                    <rds-icon namespace="filled" icon="link" (click)="openMetisLink()"></rds-icon>
                                </button>
                            </div>
                        }
                    </rds-form-field>
                </form>
            </div>
            <rds-divider></rds-divider>
            <div id="custom-data">
                <h4 class="ui-heading-4--m">Custom Data</h4>
                <div class="rds-form-field">
                    <section class="list">
                        <p class="rds-form-field__label list-label">Keywords</p>
                        <div class="list-content">
                            @for (keyword of form.controls.keyWords.controls; track keyword) {
                                <rds-form-field labelPosition="side-left">
                                    <input rdsInput [formControl]="keyword" data-testid="keywords" (keypress)="onKeywordKeypress($event)"/>
                                    <div class="d-flex align-items-center justify-content-end"  [style.visibility]="editorActionsVisible">
                                        <button rds-control-suffix rds-icon-button (click)="removeKeyword($index)"
                                                size="s" class="ms-2" data-testid="keyword-remove">
                                            <rds-icon namespace="outlined" icon="close"/>
                                        </button>
                                    </div>
                                </rds-form-field>
                            }
                        </div>
                    </section>
                    <button rds-text-button (click)="addKeyword()" class="ms-auto" type="button" data-testid="keyword-add" [style.visibility]="editorActionsVisible">
                        <rds-icon namespace="filled" icon="plus"/>
                        Add Keywords
                    </button>
                </div>
              <app-expandable-input label="Notes" [control]="form.controls.notes" [data-testid]="'notes'"></app-expandable-input>
              

              
              @if(!isViewer){
                <rds-divider></rds-divider>
                <div id="editable">
                    <rds-switch formControlName="isVisible" labelPosition="before" [checked]="form.controls.isVisible">Visible for viewers?</rds-switch>
                </div>
            }

            </div>
        </div>
        <button rds-primary-button class="ms-auto" type="submit" [disabled]="isLoadingChanges()" data-testid="submit" [style.visibility]="editorActionsVisible">
            @if (!isLoadingChanges()) {
                Save
            } @else {
                <rds-progress-spinner label="Updating..." size="m"></rds-progress-spinner>
            }
        </button>
    </form>
</div>
